import { css } from '@emotion/css';
import { Theme } from '@mui/material';

import { HEADER_HEIGHT } from '../../../../layout/chromeSizes';

export const useMenuContainerStyles = (theme: Theme) => {
  const isDarkTheme = theme.palette.mode === 'dark';
  const background = isDarkTheme ? theme.palette.background.paper : '#ffffff';

  return {
    root: css({
      flexDirection: 'row',
      marginBottom: 0,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: theme.zIndex.drawer + 2,
      background,
      borderBottom: `1px solid ${isDarkTheme ? theme.palette.grey[200] : 'rgba(226,232,240,0.7)'}`,
    }),
    appBar: css({
      boxShadow: '0 20px 35px -25px rgba(15,23,42,0.25)',
      zIndex: theme.zIndex.appBar + 1,
      background,
      '&.MuiAppBar-root': {
        margin: 0,
        padding: 0,
        minHeight: HEADER_HEIGHT,
      },
    }),
    toolBar: css({
      '&.MuiToolbar-root': {
        minHeight: HEADER_HEIGHT,
        maxHeight: HEADER_HEIGHT,
        paddingLeft: theme.spacing(4),
        paddingRight: theme.spacing(4),
        // The small menu has its own padding, and a phone has no width to spare.
        [theme.breakpoints.down('sm')]: {
          paddingLeft: 0,
          paddingRight: 0,
        },
      },
      overflow: 'hidden',
    }),
    largeMenuContainer: css({
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    }),
    smallMenuContainer: css({
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        display: 'block',
      },
      [theme.breakpoints.up('sm')]: {
        display: 'none',
      },
    }),
  };
};
